import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";
import CustomPagination from "examples/CustomPagination/CustomPagination";
import nonActiveDealerTableData from "layouts/nonApprovedDealers/data/nonActiveDealerTableData";
import { debounce } from "lodash";
import useDashboard from "hooks/useDashboard";
import useDealer from "hooks/useDealer";
function Tables() {
  const { nonApprovedDealers, nonActiveDealers } = useDealer();
  const { columns, rows } = nonActiveDealerTableData();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);
  const { searchTerm } = useDashboard();

  // Function to fetch dealers
  const getNonApprovedDealers = () => {
    const query = searchTerm.length >= 3 ? searchTerm : ""; // Apply search only if length >= 3
    nonApprovedDealers({ limit, page, search: query });
  };

  // Debounced search function
  const debouncedgetNonApprovedDealers = debounce(getNonApprovedDealers, 500);

  // Initial Load (Mandatory)
  useEffect(() => {
    getNonApprovedDealers(); // Always fetch initial data on mount
  }, []);

  // Search & Pagination Updates
  useEffect(() => {
    if (searchTerm.length === 0 || searchTerm.length >= 3) {
      debouncedgetNonApprovedDealers();
    }
    return () => debouncedgetNonApprovedDealers.cancel(); // Cleanup debounce
  }, [searchTerm, page, limit]);

  useEffect(() => {
    if (nonActiveDealers.page && nonActiveDealers.limit) {
      setPage(nonActiveDealers.page);
      setLimit(nonActiveDealers.limit);
      setTotalPage(nonActiveDealers.pages || 1);
      setTotal(nonActiveDealers.total || 0);
    }
  }, [nonActiveDealers]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    nonApprovedDealers({ limit: 10, page: newPage });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Non Approved Dealers Table
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
            <MDBox
              sx={{ width: "100%", display: "flex", justifyContent: "start", marginTop: "1rem" }}
            >
              <CustomPagination
                totalCount={totalPage}
                currentPage={page}
                onPageChange={handlePageChange}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Tables;
